const Quantity = ({ children }) => {
  return <span className="squared-count">{children}</span>;
};

export default Quantity;
